import React from "react";
import { createRoot } from "react-dom/client";
import AbsoluteGuard from "./App";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AbsoluteGuard />
  </React.StrictMode>
);
